module.exports = __webpack_public_path__ + "img/normal.749d6548.svg";